const setCustomLayerChanges = (config) => {
    return {
        type: 'SET_CUSTOM_LAYER',
        payload: config
    };
};
const updateCustomLayerChanges = (changes) => {
    return {
        type: 'UPDATE_CUSTOM_LAYER',
        payload: changes
    };
};
const updateBothLayers = (changes) => {
    return {
        type: 'UPDATE_BOTH_CUSTOM_LAYERS',
        payload: changes
    };
};
const resetCustomLayer = (changes) => {
    return {
        type: 'RESET_CUSTOM_LAYER',
        payload: changes
    };
};

const resetLeftCustomLayer = (change) => {
    return {
        type: 'RESET_LEFT_CUSTOM_LAYER',
        payload: change
    };
};
const resetRightCustomLayer = (change) => {
    return {
        type: 'RESET_RIGHT_CUSTOM_LAYER',
        payload: change
    };
};
const setFlipControlButton = (buttonState) => {
    return {
        type: 'SET_FLIP_CONTROL_BUTTON',
        payload: buttonState
    };
};

const setMirrorControlButton = (buttonState) => {
    return {
        type: 'SET_MIRROR_CONTROL_BUTTON',
        payload: buttonState
    };
};

const flipCustomLayer = (changes) => {
    return {
        type: 'FLIP_CUSTOM_LAYERS',
        payload: changes
    };
};

const centerCustomLayer = (changes) => {
    return {
        type: 'CENTER_CUSTOM_LAYERS',
        payload: changes
    };
};

export default {
    setCustomLayerChanges,
    updateCustomLayerChanges,
    resetCustomLayer,
    resetLeftCustomLayer,
    resetRightCustomLayer,
    updateBothLayers,
    flipCustomLayer,
    centerCustomLayer,
    setFlipControlButton,
    setMirrorControlButton
};
